import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'p-maintenance-dialog',
    templateUrl: './maintenance-dialog.html',
    styleUrls: ['./maintenance-dialog.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceDialogComponent {
    imageSource = 'assets/img/maintenance.svg';

    constructor(
        public dialogRef: MatDialogRef<MaintenanceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { contextParameters: any; dontShowAgain: boolean }
    ) {}

    getStartDate(timeZone: string): string {
        if (this.isOldDateFormat()) {
            return timeZone === 'UTC' ? this.data.contextParameters.serviceDownDateStart : '';
        }
        return this.getDateString('serviceDownDateStart', timeZone);
    }

    getEndDate(timeZone: string): string {
        if (this.isOldDateFormat()) {
            return timeZone === 'UTC' ? this.data.contextParameters.serviceDownDateEnd : '';
        }
        return this.getDateString('serviceDownDateEnd', timeZone);
    }

    get footerConfig() {
        return [
            {
                click: () => this.close(),
                text: 'Actions.gotIt'
            }
        ];
    }

    close(): void {
        this.dialogRef.close(this.data.dontShowAgain);
    }

    changeValue(value: boolean): void {
        this.data.dontShowAgain = value;
    }

    private getDateString(dateProperty: string, timeZone: string): string {
        let dateParts = this.data.contextParameters[dateProperty][timeZone];
        return timeZone === 'UTC' ? `${dateParts.day}, ${dateParts.time}` : this.buildESTDate(dateParts.day, dateParts.time);
    }

    private buildESTDate(ESTDay: string, ESTTime: string): string {
        return this.showLongEstDate() ? `(${ESTDay}, ${ESTTime})` : ` (${ESTTime})`;
    }

    private isOldDateFormat(): boolean {
        return typeof this.data.contextParameters[0] === 'string';
    }

    private showLongEstDate(): boolean {
        return (
            !this.isSameDate(this.data.contextParameters.serviceDownDateStart) ||
            !this.isSameDate(this.data.contextParameters.serviceDownDateEnd)
        );
    }

    private isSameDate(dateDetails: any): boolean {
        return dateDetails.UTC.day == dateDetails.EST.day;
    }
}
